import { CommandItem } from "@/components/ui/command";
import { Body } from "@hypercard/web-components";
import { CaretRight } from "@phosphor-icons/react";

export const CustomFieldItem = ({
  customFieldName,
  onSelect,
}: {
  customFieldName: string;
  onSelect: (customFieldName: string) => void;
}) => (
  <CommandItem
    key={customFieldName}
    value={customFieldName}
    onSelect={() => {
      onSelect(customFieldName);
    }}
    className="py-2"
  >
    <div className="flex w-full items-center justify-between">
      <Body size="sm" weight="medium">
        {`Search ${customFieldName}`}
      </Body>
      <CaretRight weight="bold" className="size-4 shrink-0" />
    </div>
  </CommandItem>
);
